<div class="m-4 flex items-center justify-between">
  <div></div>
  <div class="typo-h5-semibold text-text-secondary">
    {{ 'schedule_event_details_sidebar_title' | translate }}
  </div>
  <button class="text-primary-blue" (click)="onCloseClick()">
    <svg-icon size="md" key="px-24-x"></svg-icon>
  </button>
</div>
@if (selectedEvent()) {
  <div class="flex h-full flex-col overflow-scroll">
    <lib-event-details [eventDetails]="selectedEvent()"></lib-event-details>
  </div>
}
